'use client';

import { ReactNode } from 'react';

import { useSection } from '@/hooks/useSection';

import StarBackground from '../StarBackground';

interface SectionProps {
	children: ReactNode;
	id?: string;
	className?: string;
	title?: string;
	subtitle?: string;
	variant?: 'default' | 'darker';
	fullHeight?: boolean;
	align?: 'left' | 'center';
}

export function Section({
	children,
	id,
	className = '',
	title,
	subtitle,
	variant = 'default',
	fullHeight = true,
	align = 'center',
}: SectionProps) {
	const { sectionRef } = useSection();

	return (
		<section
			ref={sectionRef}
			id={id}
			className={`scroll-section relative ${!fullHeight ? 'auto-height' : ''} ${
				variant === 'darker' ? 'bg-dark-darker' : 'bg-dark'
			} ${className}`}>
			<StarBackground />

			{/* Optional decorative gradient */}
			<div className="absolute inset-0 bg-gradient-to-b from-transparent via-matrix-500/5 to-transparent opacity-50" />

			<div className="section-content md:pt-[50px]">
				<div className="mx-auto w-full max-w-7xl px-4 pb-6 pt-8 sm:px-6 sm:pb-6 sm:pt-12 lg:px-8">
					{(title || subtitle) && (
						<div
							className={`mb-12 sm:mb-16 ${align === 'center' ? 'text-center' : 'max-w-3xl text-left'}`}>
							{title && (
								<h2 className="text-3xl font-bold tracking-tight text-gray-100 sm:text-4xl lg:text-5xl">
									{title}
								</h2>
							)}
							{subtitle && (
								<p className="mx-auto mt-4 max-w-3xl text-lg text-gray-300 sm:text-xl">
									{subtitle}
								</p>
							)}
						</div>
					)}
					<div className={`mx-auto ${align === 'center' ? 'max-w-7xl' : 'max-w-6xl'}`}>
						{children}
					</div>
				</div>
			</div>
		</section>
	);
}
